import _ from 'lodash'

function populatePricesFromBackend(productList, products) {
  _.forEach(productList, (productData, key) => {
    var prices = productData
    var currentKey = key
    _.forEach(products, (product) => {
      if(product.id === currentKey) {
        _.set(product, 'lowestPrice', prices.lowestPrice)
        _.forEach(product.items, (item) => {
          var price = _.filter(prices.items, priceItem => priceItem.itemId === item.id)[0]
          if(price !== null && price !== undefined && price.itemId === item.id) {
            _.set(item, 'customerPrice', price)
          }
        })
      }
    })
  })
}

export default { populatePricesFromBackend }
